module.exports = __webpack_public_path__ + "static/media/little_victory_3_filter.4aba510d.png";